import "node-waves";


export default {
    init: function ( $element ) {
        "use strict";
        var _this = this;

        _this.$groupOfButtons = $( '.dropdown, .dropup, .btn-group' );

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this;

        _this.$groupOfButtons.on( {
            "show.bs.dropdown": function () {
                var dropdown = _this.dropdownEffect( this );
                _this.dropdownEffectStart( dropdown, dropdown.effectIn );
            },
            "shown.bs.dropdown": function () {
                var dropdown = _this.dropdownEffect( this );
                if ( dropdown.effectIn && dropdown.effectOut ) {
                    _this.dropdownEffectEnd( dropdown, function () {} );
                }
            },
            "hide.bs.dropdown": function ( e ) {
                var dropdown = _this.dropdownEffect( this );
                if ( dropdown.effectOut ) {
                    e.preventDefault();
                    _this.dropdownEffectStart( dropdown, dropdown.effectOut );
                    _this.dropdownEffectEnd( dropdown, function () {
                        dropdown.dropdown.removeClass( 'open' );
                    } );
                }
            }
        } );

        // Set Waves
        Waves.attach( '.dropdown-menu li a', [ 'waves-block' ] );
        Waves.init();
    },

    dropdownEffect: function ( target ) {
        var effectIn = VtAdmin.options.dropdownMenu.effectIn,
            effectOut = VtAdmin.options.dropdownMenu.effectOut;
        var dropdown = $( target ),
            dropdownMenu = $( '.dropdown-menu', target );

        if ( dropdown.size() > 0 ) {
            var udEffectIn = dropdown.data( 'effect-in' );
            var udEffectOut = dropdown.data( 'effect-out' );
            if ( udEffectIn !== undefined ) {
                effectIn = udEffectIn;
            }
            if ( udEffectOut !== undefined ) {
                effectOut = udEffectOut;
            }
        }

        return {
            target: target,
            dropdown: dropdown,
            dropdownMenu: dropdownMenu,
            effectIn: effectIn,
            effectOut: effectOut
        };
    },

    dropdownEffectStart: function ( data, effectToStart ) {
        if ( effectToStart ) {
            data.dropdown.addClass( 'dropdown-animating' );
            data.dropdownMenu.addClass( 'animated dropdown-animated' );
            data.dropdownMenu.addClass( effectToStart );
        }
    },

    dropdownEffectEnd: function ( data, callback ) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        data.dropdown.one( animationEnd, function () {
            data.dropdown.removeClass( 'dropdown-animating' );
            data.dropdownMenu.removeClass( 'animated dropdown-animated' );
            data.dropdownMenu.removeClass( data.effectIn );
            data.dropdownMenu.removeClass( data.effectOut );

            if ( typeof callback == 'function' ) {
                callback();
            }
        } );
    }
};
